// Package imports
import React, { useState } from "react";

// Custom imports
import MCQ from "./Types/MCQ";
import TF from "./Types/TF";
import RTS from "./Types/RTS";
import JW from "./Types/JW";
import DIC from "./Types/DIC";
import SF from "./Types/SF";
import MEDIA from "./Types/MEDIA";
import WORD from "./Types/WORD";
import FIBTYPO from "./Types/FIB/FIBTYPO";
import FIBSELECT from "./Types/FIB/FIBSELECT";
import FIBDND from "./Types/FIB/FIBDND";
import REC from "./Types/REC";
import ILT from "./Types/ILT";
import BG from "./Types/BG";
import RA from "./Types/RA";
import OP from "./Types/OP";
import SB from "./Types/SB";
import CI from "./Types/CI";
import OO from "./Types/OO";
import WS from "./Types/WS";
import AVP from "./Types/AVP";
import MATCH from "./Types/MATCH";
import TFS from "./Types/TFS";
import IE from "./Types/IE";
import NB from "./Types/NB";
import THESAURUS from "./Types/THESAURUS";
import WORDGROUP from "./Types/WORDGROUP";
import BINGO from "./Types/BINGO";
import VIDEOREC from "./Types/VIDEOREC";
import RECADV from "./Types/RECADV";

// Global variables

// Component
function ContentTypeCheck(props) {
  // State
  const [breadcrumb, setBreadcrumb] = useState(null);
  // JSX template
  return (
    <>
      {props.content && props.content.info.asset_type_alias == "MC" && (
        <MCQ content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "TF" && (
        <TF content={props.content} />
      )}
      {props.content &&
        props.content.info.asset_type_alias == "COMP" &&
        props.content.info.asset_subtype ==
          "25995fff-7016-4b0d-9a82-75d8e39ae662" && (
            <MCQ content={props.content} />
        )}
        {props.content &&
        props.content.info.asset_type_alias == "COMP" &&
        props.content.info.asset_subtype ==
          "4b5cb5e4-7b7e-4e2d-be06-abe98dfdc495" && (
            <TF content={props.content} />
        )}
      {props.content && props.content.info.asset_type_alias == "RTS" && (
        <RTS content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "JW" && (
        <JW content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "DIC" && (
        <DIC content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "SF" && (
        <SF content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "MEDIA" && (
        <MEDIA content={props.content} />
      )}
      {props.content &&
        props.content.info.asset_type_alias == "FIB" &&
        (props.content.info.asset_subtype == "" ||
        props.content.info.asset_subtype ==
          "d16b4024-7755-4dfc-950b-f7c4171ad576") && (
          <FIBTYPO content={props.content} />
        )}
      {props.content &&
        props.content.info.asset_type_alias == "FIB" &&
        props.content.info.asset_subtype ==
          "c33b4b2d-629e-49c8-893d-71a137b348f3" && (
          <FIBDND content={props.content} />
        )}
      {props.content &&
        props.content.info.asset_type_alias == "FIB" &&
        props.content.info.asset_subtype ==
          "26c427b4-dbd2-4041-afe2-19b7c448b4bf" && (
          <FIBSELECT content={props.content} />
        )}
      {props.content && props.content.info.asset_type_alias == "WORD" && (
        <WORD content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "REC" && (
        <REC content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "ILT" && (
        <ILT content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "BG" && (
        <BG content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "RA" && (
        <RA content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "OP" && (
        <OP content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "SB" && (
        <SB content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "CI" && (
        <CI content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "OO" && (
        <OO content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "WS" && (
        <WS content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "AVP" && (
        <AVP content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "MATCH" && (
        <MATCH content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "TFS" && (
        <TFS content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "IE" && (
        <IE content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "NB" && (
        <NB content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "THESAURUS" && (
        <THESAURUS content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "WORDGROUP" && (
        <WORDGROUP content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "BINGO" && (
        <BINGO content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "VIDEOREC" && (
        <VIDEOREC content={props.content} />
      )}
      {props.content && props.content.info.asset_type_alias == "RECADV" && (
        <RECADV content={props.content} />
      )}
      {/*{props.content &&
        props.content.info.asset_type_alias == "FIB" &&
        props.content.info.asset_subtype ==
          "c33b4b2d-629e-49c8-893d-71a137b348f3" && (
          <FIBDND
            content={props.content}
            checkOrientation={props.checkOrientation}
          />
        )}
      {props.content && props.content.info.asset_type_alias == "ILT" && (
        <ILT
          content={props.content}
          checkOrientation={props.checkOrientation}
        />
      )}
      */}
    </>
  );
}

export default ContentTypeCheck;
